import { Icon } from '@ets/design-system';

type BooleanCellProps = {
  value: boolean | undefined | null;
  testId: string;
};
const BooleanCell = ({ value, testId }: BooleanCellProps) => {
  return value ? (
    <Icon icon="check" size="3" color="success" testId={`${testId}`} data-value={value} />
  ) : (
    <Icon icon="xmark" size="3" color="error" testId={`${testId}`} data-value={value} />
  );
};

export default BooleanCell;
